import React, {Fragment, useEffect, useContext} from "react";
import PropTypes from "prop-types";
import OrganisationTable from "root/Tables/OrganisationTable";
import SpinnerDiv from "root/Components/SpinnerDiv";
import AdminModuleContext from "../../AdminModuleContext";
import useModalAddTeam from "root/Modals/AddTeam/useModalAddTeam";

const OrganisationsTab = (props) =>
{
    const organisations = useContext(AdminModuleContext) ;

    useEffect(() => {
        organisations.getOrganisations() ;
        organisations.setHeader ( 'Organisations') ;
    }, []);

    // Open add team modal
    const [renderAddTeamModal, showAddTeamModal] = useModalAddTeam( (result) =>
    {
        //
    })

    const onClickOrganisation = ( organisation_id, mode ) =>
    {
        switch(mode){
            case 'team':
                showAddTeamModal('create', organisation_id);
                break;

            default:
                organisations.activateOrganisationModal ( organisation_id, mode ) ;
        }
    }

    return (
        <Fragment>
            {organisations.isLoading && <SpinnerDiv/>}
            {!organisations.isLoading && <OrganisationTable data={organisations.organisationData} isLoading={organisations.isOrganisationLoading} clickHandler={onClickOrganisation}/>}

            {renderAddTeamModal(props)}
        </Fragment>
    )
}

OrganisationsTab.defaultProps = {};

export default OrganisationsTab;

OrganisationsTab.propTypes = {};
